import { Route, Routes } from "react-router-dom";
import About from "../views/aboutUs/aboutUs";
import Certificate from "../views/certificate/certificate";
import Complaint from "../views/complaint/complaint";
import Consuling from "../views/consuling/consuling";
import DataSheet from "../views/dataSheet/dataSheet";
import DeviceStatus from "../views/deviceStatus/deviceStatus";
import Education from "../views/education/education";
import EducationDetail from "../views/education/educationDetail";
import ExplodedDrawing from "../views/explodedDrawing/explodedDrawing";
import Home from "../views/home/home";
import Login from "../views/authentication/login";
import LoginBySerial from "../views/authentication/loginBySerial";
import Logout from "../views/authentication/logout";
import News from "../views/news/news";
import NewsDetail from "../views/news/newsDetail";
import PageNotFound from "../views/pageNotFound/pageNotFound";
import PartRequst from "../views/partRequest/PartRequest";
import ProductDetail from "../views/products/ProductDetail";
import Products from "../views/products/Products";
import Profile from "../views/Profile/profile";
import Representation from "../views/representations/representation";
import ServiceCenter from "../views/serviceCenter/serviceCenter";
import UnderConstruction from "../views/underConstruction/UnderConstruction";
import Sizing from "../views/sizing/sizing";
import SizingWithoutHeader from "../views/sizing/sizingWithoutHeader";
import UserInfo from "../views/Profile/userInfo";
import VisitHistory from "../views/visitHistory/visitHistory";
import VisitHistoryBySerial from "../views/visitHistory/visitHistoryBySerial";
import ProductsFiles from "../views/productsFiles/productsFiles";
import AboutApp from "../views/aboutApp/aboutApp";
import ProductAuthenticityVerification from "../views/ProductAuthenticityVerification/ProductAuthenticityVerification";

function appRoutes() {
    return (
        <Routes>
            <Route exact path="/ProductAuthenticityVerification" element={<ProductAuthenticityVerification />} />
            <Route exact path="/aboutApp" element={<AboutApp />} />
            <Route exact path="/underConstruction/:id" element={<UnderConstruction />} />
            <Route exact path="/productsFiles/:id" element={<ProductsFiles />} />
            <Route exact path="/serviceRequest" element={<ServiceCenter />} />
            <Route exact path="/representation" element={<Representation />} />
            <Route exact path="/certificate" element={<Certificate />} />
            <Route exact path="/explodedDrawing" element={<ExplodedDrawing />} />
            <Route exact path="/dataSheet" element={<DataSheet />} />
            <Route exact path="/visitHistory" element={<VisitHistory />} />
            <Route exact path="/visitHistoryBySerial" element={<VisitHistoryBySerial />} />
            <Route exact path="/complaint" element={<Complaint />} />
            <Route exact path="/partRequst/:id" element={<PartRequst />} />
            <Route exact path="/consuling" element={<Consuling />} />
            <Route exact path="/sizing" element={<SizingWithoutHeader />} />
            <Route exact path="/appSizing" element={<Sizing />} />
            <Route exact path="/educationDetail/:id" element={<EducationDetail />} />
            <Route exact path="/education" element={<Education />} />
            <Route exact path="/newsDetail/:id" element={<NewsDetail />} />
            <Route exact path="/news" element={<News />} />
            <Route exact path="/productDetail/:id" element={<ProductDetail />} />
            <Route exact path="/products" element={<Products />} />
            <Route exact path="/userInfo" element={<UserInfo />} />
            <Route exact path="/profile" element={<Profile />} />
            <Route exact path="/deviceStatus" element={<DeviceStatus />} />
            <Route exact path="/loginBySerial" element={<LoginBySerial />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/logout" element={<Logout />} />
            <Route exact path="/about" element={<About />} />
            <Route exact path="/" element={<Home />} />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    );
}

export default appRoutes;
